import { render, staticRenderFns } from "./AdditionalCharges.vue?vue&type=template&id=55720dec&lang=pug"
import script from "./AdditionalCharges.vue?vue&type=script&lang=js"
export * from "./AdditionalCharges.vue?vue&type=script&lang=js"
import style0 from "./AdditionalCharges.vue?vue&type=style&index=0&id=55720dec&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports